import React, { forwardRef } from 'react'
import { withTranslation } from 'react-i18next'
import * as UIcons from '@iconscout/react-unicons'
import ClickAwayComponent from 'components/ClickAwayComponent'

function FilterPill({ label, active, options, onSelect }) {
  return (
    <ClickAwayComponent
      Component={forwardRef(({ handleClick, open }, ref) => (
        <div className="relative" ref={ref}>
          <button
            type="button"
            onClick={handleClick}
            className="flex items-center gap-2 bg-background rounded-full h-10 px-4 text-sm font-medium text-dark-blue whitespace-nowrap"
          >
            {active?.label ?? label}
            {open ? <UIcons.UilAngleUp size={16} className="text-secondary" /> : <UIcons.UilAngleDown size={16} className="text-secondary" />}
          </button>

          {
            open && (
              <div className="absolute left-0 top-11 z-20 w-56 bg-white border border-border-lines rounded-xl shadow-lg py-2">
                <ul className="max-h-60 overflow-y-auto">
                  {
                    options.map((option) => (
                      <li key={option.value ?? 'all'}>
                        <button
                          type="button"
                          onClick={() => { onSelect(option); handleClick() }}
                          className="w-full text-left px-4 py-2 text-sm text-dark-blue hover:bg-background"
                        >
                          {option.label}
                        </button>
                      </li>
                    ))
                  }
                </ul>
              </div>
            )
          }
        </div>
      ))}
    />
  )
}

export default withTranslation()(function ContactFilterBar({ t, q, onChangeQ, type, onChangeType, status, onChangeStatus }) {
  const typeOptions = [
    { label: t('settings.business_organization.contact_person.filters.all_types'), value: '' },
    { label: t('settings.business_organization.contact_person.types.primary'), value: 'primary' },
    { label: t('settings.business_organization.contact_person.types.general'), value: 'general' },
    { label: t('settings.business_organization.contact_person.types.feedback'), value: 'feedback' }
  ]

  const statusOptions = [
    { label: t('settings.business_organization.contact_person.filters.all_statuses'), value: '' },
    { label: t('settings.business_organization.contact_person.filters.active'), value: 'active' },
    { label: t('settings.business_organization.contact_person.filters.inactive'), value: 'inactive' }
  ]

  return (
    <div className="flex flex-wrap items-center gap-3 mb-4">
      <div className="relative flex-1 min-w-[220px] max-w-xs">
        <input
          type="text"
          value={q}
          onChange={(event) => onChangeQ(event.target.value)}
          className="w-full bg-grey rounded-lg pl-10 pr-3 py-2.5 text-sm outline-none"
          placeholder={t('settings.business_organization.contact_person.filters.search_placeholder')}
        />
        <UIcons.UilSearch className="text-placeholder absolute top-1/2 -translate-y-1/2 left-3" size={16} />
      </div>

      <FilterPill
        label={t('settings.business_organization.contact_person.filters.all_types')}
        active={type ? { label: typeOptions.find((option) => option.value === type)?.label } : null}
        options={typeOptions}
        onSelect={(option) => onChangeType(option.value)}
      />

      <FilterPill
        label={t('settings.business_organization.contact_person.filters.all_statuses')}
        active={status ? { label: statusOptions.find((option) => option.value === status)?.label } : null}
        options={statusOptions}
        onSelect={(option) => onChangeStatus(option.value)}
      />
    </div>
  )
})
